import {Trans, useTranslation} from '@/translations/i18n'
import {AccessDashboardCard} from '../access-dashboard-card/AccessDashboardCard'
import {useGetAccessesDashboard} from '../../queries/useGetAccessesDashboard'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {filtersParamToPayload} from '@/utilities/helpers'
import {AccessesTableDashboardEmptyState} from '../accesses-table-dashboard/AcccessesTableDashboardEmptyState'
import {Text} from '@/components/ui/text/Text'
import {AccessesSearchParams} from '../../types'
import {useAccessesCardFilterChecks} from '../../hooks/useAccessesCardFilterChecks'

export const AccessesDashboardSingleAccessesCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(AccessesSearchParams)

    const {isFilteringFor} = useAccessesCardFilterChecks({
        filters: searchParams.filters,
        filterKeys: ['projectCode']
    })

    const {data, isLoading} = useGetAccessesDashboard<'in_person_accesses'>({
        payload: {
            filters: filtersParamToPayload(searchParams.filters)?.filters
        },
        params: {
            card: 'in_person_accesses',
            startDate: searchParams.startDate,
            endDate: searchParams.endDate
        }
    })

    if (isLoading || !data) {
        return (
            <AccessesTableDashboardEmptyState title={t('accesses:dashboard_single_accesses')} isLoading={isLoading} />
        )
    }

    return (
        <AccessDashboardCard title={t('accesses:dashboard_single_accesses')}>
            <Text size="textSm" palette="neutral" shade="600">
                {isFilteringFor('projectCode') ? (
                    <Trans
                        i18nKey="accesses:dashboard_single_accesses_subtitle"
                        values={{count: data?.inPersonAccesses.done, total: data?.inPersonAccesses.planned}}
                        components={[
                            <Text render="span" size="textLg" palette="neutral" shade="950" weight="600" />,
                            <Text render="span" size="textLg" palette="neutral" shade="600" weight="500" />
                        ]}
                    />
                ) : (
                    <Text size="textLg" palette="neutral" shade="950" weight="600">
                        {data?.inPersonAccesses.done}
                    </Text>
                )}
            </Text>
        </AccessDashboardCard>
    )
}
